import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { TrustBadges } from '../components/TrustBadges';
export function GuaranteeSection() {
  return <section className="py-14 md:py-20 px-6 bg-midnight-light relative overflow-hidden" data-id="element-197">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-198">
        <FadeIn className="flex flex-col items-center" data-id="element-199">
          {/* Premium Shield Badge */}
          <div className="relative mb-12 flex flex-col items-center" data-id="element-200">
            {/* Outer glow ring */}
            <div className="absolute top-4 w-32 h-32 bg-rosegold/20 rounded-full blur-2xl animate-glow-shield" data-id="element-201" />

            {/* Shield shape */}
            <div className="relative w-28 h-36 md:w-36 md:h-44 flex flex-col items-center justify-center mb-6" data-id="element-202">
              <svg viewBox="0 0 120 148" className="absolute inset-0 w-full h-full" fill="none" data-id="element-203">
                {/* Shield outline */}
                <path d="M60 8L12 32V72C12 104 32 132 60 142C88 132 108 104 108 72V32L60 8Z" stroke="url(#shieldGradient)" strokeWidth="2" fill="rgba(13,27,42,0.9)" data-id="element-204" />
                {/* Inner shield line */}
                <path d="M60 18L22 38V72C22 98 38 122 60 132C82 122 98 98 98 72V38L60 18Z" stroke="rgba(201,169,110,0.2)" strokeWidth="1" fill="none" data-id="element-205" />
                <defs data-id="element-206">
                  <linearGradient id="shieldGradient" x1="60" y1="0" x2="60" y2="148" data-id="element-207">
                    <stop offset="0%" stopColor="#D4BA85" data-id="element-208" />
                    <stop offset="50%" stopColor="#C9A96E" data-id="element-209" />
                    <stop offset="100%" stopColor="#B8944F" data-id="element-210" />
                  </linearGradient>
                </defs>
              </svg>

              {/* Content inside shield */}
              <div className="relative z-10 flex flex-col items-center justify-center h-full pt-2" data-id="element-211">
                <span className="text-4xl md:text-5xl" data-id="element-212">🛡️</span>
              </div>
            </div>

            {/* Text outside the shield */}
            <div className="flex flex-col items-center relative z-10" data-id="element-213">
              <span className="font-playfair text-3xl md:text-4xl font-bold text-rosegold leading-none mb-2 drop-shadow-[0_0_8px_rgba(201,169,110,0.4)]" data-id="element-214">
                7-Day
              </span>
              <span className="font-inter text-sm md:text-base font-bold text-rosegold uppercase tracking-[0.2em] drop-shadow-[0_0_8px_rgba(201,169,110,0.4)]" data-id="element-215">
                Money Back Guarantee
              </span>
            </div>
          </div>

          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-warmwhite mb-8 leading-tight" data-id="element-216">
            Try It. If It Doesn't Work,
            <br data-id="element-217" />
            You Pay Nothing.
          </h2>

          <div className="font-inter text-softgray text-lg space-y-6 max-w-[600px] mx-auto mb-14" data-id="element-218">
            <p data-id="element-219">
              We're so confident The Anger Circuit Breaker will give you results
              in your very first use that we're backing it with a full 7-day
              money-back guarantee.
            </p>
            <p data-id="element-220">
              Try every technique in the guide. Use the action cards in a real
              moment.
            </p>
            <p className="font-medium text-warmwhite" data-id="element-221">
              If you don't feel the difference — email us and we'll refund every
              cent.
            </p>
            <p data-id="element-222">
              No questions. No hoops. No drama. Because we know what this does
              for women who finally give it a real chance.
            </p>
          </div>

          <TrustBadges variant="grid" className="md:hidden w-full max-w-sm mx-auto" data-id="element-223" />
          <TrustBadges variant="horizontal" className="hidden md:flex" data-id="element-224" />
        </FadeIn>
      </div>
    </section>;
}